// extracted by mini-css-extract-plugin
export default {"qrContainer":"qr_qrContainer__78RK6"};